// src/routes/order.routes.js
import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
import AuthGuard from '../guards/authGuard';

// Lazy load order pages
const OrderManagement = lazy(() => import('../pages/dashboard/OrderManagement'));
const OrderDetails = lazy(() => import('../pages/dashboard/OrderDetails'));
const OrderExport = lazy(() => import('../pages/dashboard/orderExport'));

const orderRoutes = {
  path: 'orders',
  element: (
    <AuthGuard>
      <Suspense fallback={<div>Loading...</div>}>
        <Outlet />
      </Suspense>
    </AuthGuard>
  ),
  children: [
    {
      path: '',
      element: <OrderManagement mode="list" />
    },
    {
      path: ':orderId',
      element: <OrderDetails />
    },
    {
      path: 'export',
      element: <OrderExport />
    }
  ]
};

export default orderRoutes;